import { render, staticRenderFns } from "./EventAdd.vue?vue&type=template&id=28019810&scoped=true&"
import script from "./EventAdd.vue?vue&type=script&lang=js&"
export * from "./EventAdd.vue?vue&type=script&lang=js&"
import style0 from "./EventAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EventAdd.vue?vue&type=style&index=1&id=28019810&scoped=true&lang=css&"
import style2 from "./EventAdd.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28019810",
  null
  
)

export default component.exports